// extracted by mini-css-extract-plugin
module.exports = {"lives":"Lives_lives__1_-A9","heart":"Lives_heart__1f6JH"};